import { render, staticRenderFns } from "./EmbedDirectory.vue?vue&type=template&id=45939d4e&scoped=true"
import script from "./EmbedDirectory.vue?vue&type=script&lang=js"
export * from "./EmbedDirectory.vue?vue&type=script&lang=js"
import style0 from "./EmbedDirectory.vue?vue&type=style&index=0&id=45939d4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45939d4e",
  null
  
)

export default component.exports